/** QuickTicketing — Pièces jointes préparées dans le navigateur.
 *  Images : réduites (images.js, grand côté ≤ 1568 px). Autres fichiers (journaux,
 *  exports…) : envoyés tels quels, 10 Mo au plus. */
import { prepareImage } from './images.js';

export const MAX_FILES = 8;
const MAX_BYTES = 10 * 1024 * 1024;

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result).split(',')[1] || '');
    fr.onerror = () => reject(new Error(`Lecture impossible : ${file.name}`));
    fr.readAsDataURL(file);
  });
}

/** File → { id, name, mediaType, data, preview? } */
export async function prepareFile(file) {
  if (/^image\/(png|jpeg|gif|webp|bmp)$/.test(file.type)) return prepareImage(file);
  if (file.size > MAX_BYTES) throw new Error(`« ${file.name} » dépasse 10 Mo`);
  return {
    id: `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`,
    name: file.name,
    mediaType: file.type || 'application/octet-stream',
    data: await toBase64(file),
    preview: null,
  };
}

/** Fichiers d'un presse-papiers, d'un glisser-déposer ou d'un <input type=file>. */
export function filesOf(list) {
  const out = [];
  for (const item of list ?? []) {
    const f = item instanceof File ? item : item.kind === 'file' ? item.getAsFile() : null;
    if (f) out.push(f);
  }
  return out;
}

/** Pour l'envoi : sans l'aperçu local. */
export const payload = (files) => files.map(({ name, mediaType, data }) => ({ name, mediaType, data }));
